import request from '@/utils/request'

export async function getVehicle(data) {
  return request({
    url: '/device/record/car/page',
    method: 'post',
    data,
  })
}

export async function getPerson(data) {
  return request({
    url: '/device/record/person/page',
    method: 'post',
    data,
  })
}